const cacheConfig = [
    // { expiry: <milisegundos>, method: '<verbo HTTP ou *>', endpoint: '<permite uso do wildcard *>',}
    { expiry: 0, method: 'GET', endpoint: '/arquivos/*' },
    { expiry: 500, method: 'GET', endpoint: '/notificacoes' },
    { expiry: 500, method: 'GET', endpoint: '/notificacoes/*' },
    { expiry: 120000, method: 'GET', endpoint: '/schema' },
    { expiry: 120000, method: 'GET', endpoint: '/config' },
    { expiry: 120000, method: 'GET', endpoint: '/tabelas/*' },
    // { expiry: 30000, method: 'GET', endpoint: '/me' },
    { expiry: 120000, method: 'GET', endpoint: '/workspace/dadosgerais/*' },
    // { expiry: 60000, method: 'GET', endpoint: '/favoritos/unico/*/proposicao' },
    // { expiry: 60000, method: 'GET', endpoint: '/proposicao/*/acontecimentos' },
    // { expiry: 60000, method: 'GET', endpoint: '/proposicao/*/acao-preparatoria' },
    // { expiry: 60000, method: 'GET', endpoint: '/proposicao/*/emendas' },
    // { expiry: 60000, method: 'GET', endpoint: '/proposicao/*/correlatas' },
    // { expiry: 60000, method: 'GET', endpoint: '/usuario/departamento' },
    // { expiry: 60000, method: 'GET', endpoint: '/usuario' },
    // Configuração padrão para todas as as requisições tipo GET não configuradas acima. Manter sempre por último entre os GETs!
    { expiry: 2000, method: 'GET', endpoint: '/*' },
];

export default cacheConfig;
